import React from 'react';
import { airlines } from '../mock';
import { useLanguage } from '../contexts/LanguageContext';
import { Plane } from 'lucide-react';

const Airlines = () => {
  const { t } = useLanguage();

  return (
    <section id="compagnies" className="py-24 bg-gradient-to-b from-white via-blue-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-blue-100 px-4 py-2 rounded-full mb-4">
            <Plane className="text-blue-600" size={18} />
            <span className="text-sm font-semibold text-blue-700">Partenaires Officiels</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('ourPartners')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('airlinesSubtitle')}
          </p>
        </div>

        {/* Airlines Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {airlines.map((airline) => (
            <div
              key={airline.id}
              className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 overflow-hidden border border-gray-100"
              data-testid={`airline-${airline.id}`}
            >
              {/* Top color bar */}
              <div
                className="h-2 w-full"
                style={{ background: `linear-gradient(90deg, ${airline.color}, ${airline.accent})` }}
              />

              <div className="p-6">
                {/* Airline Code & Flag */}
                <div className="flex items-center justify-between mb-4">
                  <div
                    className="w-14 h-14 rounded-xl flex items-center justify-center text-white font-bold text-lg shadow-md group-hover:scale-110 transition-transform duration-300"
                    style={{ backgroundColor: airline.color }}
                  >
                    {airline.code}
                  </div>
                  <span className="text-3xl" role="img" aria-label={airline.country}>
                    {airline.flag}
                  </span>
                </div>

                {/* Airline Name */}
                <h3 className="text-lg font-bold text-gray-900 mb-1 leading-tight">
                  {airline.name}
                </h3>

                {/* Country */}
                <p className="text-sm text-gray-500 flex items-center gap-1">
                  <Plane size={14} className="text-blue-500" />
                  {airline.country}
                </p>
              </div>

              {/* Hover overlay effect */}
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity duration-500 pointer-events-none"
                style={{ backgroundColor: airline.color }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Airlines;
